// extracted by mini-css-extract-plugin
export default {"logo":"logo-Vjhhx","stars":"stars-_NUHi","text":"text-fl2f7","lightText":"lightText-bghHd","isFlat":"isFlat-WYMPQ","row":"row-tfkOK"};